@use '@dixa/lib-shared-tokens/scss' as *;

.withBackground {
  background: var(--dixa-color-neutral-100);
  border-radius: var(--dixa-size-border-radius-100);
}

.header {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--dixa-size-spacer-300);
}

.error {
  font-size: 12px;
  font-weight: 600;
  color: var(--dixa-color-red-700);
  padding: var(--dixa-size-spacer-200) var(--dixa-size-spacer-300);
  border-top: 1px solid var(--dixa-color-neutral-100);
}

.title {
  font-size: 14px;
  line-height: var(--dixa-size-spacer-400);
  margin: 0;
  font-weight: 600;
  color: var(--dixa-typography-color-primary);
}

.actions {
  display: flex;
  align-items: center;
}

.action {
  font-size: 12px;
  font-weight: 600;
  color: var(--dixa-color-purple-500);
  border: 0;
  background: none;
  margin-left: var(--dixa-size-spacer-200);
  line-height: var(--dixa-size-spacer-400);
  height: var(--dixa-size-spacer-400);
  border-radius: var(--dixa-size-border-radius-100);
  padding: 0 var(--dixa-size-spacer-200);
  margin-right: minus(var(--dixa-size-spacer-200));

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--dixa-color-purple-200);
  }
}

.addButton {
  margin-top: var(--dixa-size-spacer-300);
}

.rows {
  border-top: 1px solid var(--dixa-color-neutral-100);
  padding: var(--dixa-size-spacer-300);
  max-height: 404px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}
